import { useNavigate } from "react-router-dom";
import { fetchIncidentsPost } from "../../../services/api-raindrop";
import NimbusLinkCard from "../../../ui-components/nimbus-link-card/nimbus-link-card";

const NimbusIncidentsIndex = () => {
  const navigate = useNavigate();

  const onDeclareIncident = () => {
    console.log("Declare Incident");

    fetchIncidentsPost().then((data) => {
      navigate(`/nimbus/incidents/${data.id}`);
    });
  };

  return (
    <div className="flex flex-row h-full items-center justify-center text-center gap-2">
      <NimbusLinkCard
        title={"Current Incident"}
        to={"/nimbus/incidents/current"}
        icon="fa-warning"
      />
      <NimbusLinkCard
        title={"Declare an Incident"}
        icon="fa-poo-storm"
        onClick={onDeclareIncident}
      />
      <NimbusLinkCard
        to={"/nimbus/incidents/search"}
        icon={"fa-magnifying-glass"}
        title="Search Incidents"
      />
    </div>
  );
};

export default NimbusIncidentsIndex;
